import {AfterViewInit, Component, Input, NgZone, OnInit, ViewChild} from '@angular/core';
import {CdkVirtualScrollViewport} from "@angular/cdk/scrolling";
import {distinct, filter, map, pairwise, throttleTime} from "rxjs/operators";
import {Observable} from "rxjs";
import {RecentlyReport} from "../../../model/report/recently-report";
import {ReportService} from "../../../service/report.service";
import {ObligorSearchTable} from "../../../obligor-search/obligor-search-table";
import {Location} from "@angular/common";
import {TransitionTypesEnum} from "../../../model/enum/transition-types-enum";
import {RecentSearch} from "../../../model/RecentSearch";
import {ConfirmationDialogOpener} from "../../confirmation-dialog/confirmation-dialog-opener";

@Component({
  selector: 'app-recently-reports',
  templateUrl: './recently-reports.component.html',
  styleUrls: ['./recently-reports.component.scss']
})
export class RecentlyReportsComponent implements OnInit, AfterViewInit {

  @Input()
  updateRecenltyViewed$: Observable<boolean>;

  @Input()
  dirtyFlag = false;

  recentViewed: Array<RecentlyReport> = [];
  private searchResultsOffset = 0;
  private pageSize = 20;
  private viewedMoreAvailable = true;
  viewedLoading: boolean;
  @ViewChild('viewedScroller') viewedScroller: CdkVirtualScrollViewport;

  constructor(
    private confirmationDialog: ConfirmationDialogOpener,
    public obligorSearchTable: ObligorSearchTable,
    private reportService: ReportService,
    private ngZone: NgZone,
    private location: Location) {
  }

  ngOnInit(): void {
    this.loadMoreViewed();
  }

  onItemClick(obligorRecent: RecentlyReport) {
    if (this.dirtyFlag === true) {
      const ret = this.confirmationDialog.openConfirmDialog();
      ret.closeObs$.subscribe(result => {
        if (result === true) {
          this.navigate(obligorRecent);
        }
      })
    } else {
      this.navigate(obligorRecent);
    }
  }

  private navigate(obligorRecent: RecentlyReport): void {
    this.reportService.getObligorByid(obligorRecent.obligorId).subscribe({
      next: response => {
        const state: any = this.location.getState();
        let tr: TransitionTypesEnum = state?.['transitionType'];
        const rs: RecentSearch = state?.['recentSearch'];
        this.obligorSearchTable.openProReport(response.obligor, tr, rs);
      }
    });
  }

  loadMoreViewed(): void {
    if (this.viewedMoreAvailable && !this.viewedLoading) {
      this.viewedLoading = true;
      const pageNum = Math.ceil(this.searchResultsOffset / this.pageSize) + 1;
      this.reportService.getRecentlyViewedReports(this.pageSize, pageNum).subscribe({
        next: response => {
          this.recentViewed = this.recentViewed.concat(response);
          this.searchResultsOffset += response.length;
          if (response.length < this.pageSize) {
            this.viewedMoreAvailable = false;
          }
          this.viewedLoading = false;
        }, error: (e) => {
          this.viewedLoading = false;
        }
      });
    }
  }

  ngAfterViewInit(): void {
    this.viewedScroller.elementScrolled().pipe(
      map(() => this.viewedScroller.measureScrollOffset('bottom')),
      pairwise(),
      filter(([y1, y2]) => (y2 < y1 && y2 < 50)),
      throttleTime(200),
      distinct()
    ).subscribe(() => {
      this.ngZone.run(() => {
        this.loadMoreViewed();
      })
    });
  }

}
